import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { get_files_in_folder } from "./api/cloud_viewer"
import { CVFolderHeader } from "./UI/CVFolderHeader"
import { CVListContainer } from "./UI/CVListContainer"
import { CloudViewerFolders, CloudViewerProps, CVFile } from "./interface/CV_types"

/**
 * This main Route Component
 * 
 * This gets the project id and the type of folder (either 'documents' or 'proposals') from the url and passes it to the CloudViewer component
 */
export function CloudViewerContainer() {
    const {project_id, folder_name} = useParams()

    return <CloudViewer project_id={project_id ?? ""} folder_name={folder_name as CloudViewerFolders} />
}

/**
 * The main component for the cloud viewer
 * 
 * This component mainly shows the folders for either the "PDFs" or "PROPOSALS"
 * 
 * The features for this component will be as follows:
 * - Shows the contents of the folder depending on the folder name
 * - Ability to delete files from the folder
 * - Ability to download specific files
 * 
 */
export function CloudViewer({project_id, folder_name}: CloudViewerProps) {
    const [files, setFiles] = useState<CVFile[]>([])

    useEffect(() => {
        get_files_in_folder(project_id, folder_name).then((data) => {
            setFiles(data.contents.map((file: any) => ({
                name: file.name,
                size: file.size,
            })))
        })
    }, [project_id, folder_name])

    return (
        <div className="p-2">
            <CVFolderHeader project_id={project_id} folder_name={folder_name} />

            {/* We pass the contents of the folder to the CVListContainer */}
            <CVListContainer files={files} project_id={project_id} />
        </div>
    )
}
